import { render, staticRenderFns } from "./ConfiguracionComandosSMS.vue?vue&type=template&id=52b19668&scoped=true&"
import script from "./ConfiguracionComandosSMS.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionComandosSMS.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguracionComandosSMS.vue?vue&type=style&index=0&id=52b19668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b19668",
  null
  
)

export default component.exports